import React from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import { sqlDateToLabel } from 'helpers/helpers';
import useGeneralStyles from 'apps/Pdf/styles/general';
import { ContractPhysicalData, ContractPersonalData } from 'stores/workflowStores/workflowPersonalDataStore/model';

interface Props {
  data: ContractPhysicalData | ContractPersonalData;
}

const PersonalData = (props: Props) => {
  const styles = useGeneralStyles();
  const { t } = useTranslation();
  const { data } = props;

  return (
    <>
      <div className={`${styles.twoColumns} ${styles.lines}`}>
        <Grid container>
          <Grid item xs={4}>
            Jméno:
          </Grid>
          <Grid item xs={8} className={`${styles.bold} ${styles.value}`}>
            {data.degreePrefix} {data.firstname} {data.lastname}
            {data.degreeSuffix ? `, ${data.degreeSuffix}` : ''}
          </Grid>
          <Grid item xs={4}>
            Trvalá adresa:
          </Grid>
          <Grid item xs={8} className={styles.value}>
            {data.permanentAddressCompact}, {t(`country_${data.permanentAddress.country}`)}
          </Grid>
          <Grid item xs={4}>
            {t(`general_personalId_${data.foreignIdType}`)}
          </Grid>
          <Grid item xs={8} className={styles.value}>
            {data.personalNumber || data.foreignId}
          </Grid>
          <Grid item xs={4}>
            Datum narození:
          </Grid>
          <Grid item xs={8} className={styles.value}>
            {sqlDateToLabel(data.birthDate, 'dd. MM. yyyy')}
          </Grid>
          <Grid item xs={4}>
            Korespondenční adresa:
          </Grid>
          <Grid item xs={8} className={styles.value}>
            {data.contactAddressCompact ? (
              <>
                {data.contactAddressCompact}, {t(`country_${data.contactAddress.country}`)}
              </>
            ) : (
              t('contract_contactAddress_same')
            )}
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={4}>
            Pohlaví:
          </Grid>
          <Grid item xs={8} className={styles.value}>
            {t(`gender_${data.gender}`)}
          </Grid>

          {'taxResidency' in data && (
            <>
              <Grid item xs={4}>
                Stát daňové rezidence:
              </Grid>
              <Grid item xs={8} className={styles.value}>
                {t(`country_${data.taxResidency.country}`)}
              </Grid>
              {data.taxResidency.taxNumber && (
                <>
                  <Grid item xs={4}>
                    DIČ:
                  </Grid>
                  <Grid item xs={8} className={styles.value}>
                    {data.taxResidency.taxNumber.number}
                  </Grid>
                </>
              )}
            </>
          )}
          <Grid item xs={4}>
            Místo narození:
          </Grid>
          <Grid item xs={8} className={styles.value}>
            {t(`country_${data.countryOfBirth}`)}, {data.placeOfBirth}
          </Grid>
          <Grid item xs={4}>
            Státní příslušnost:
          </Grid>
          <Grid item xs={8} className={styles.value}>
            {t(`country_${data.citizenship}`)}
          </Grid>
          <Grid item xs={4}>
            Průkaz totožnosti:
          </Grid>
          <Grid item xs={8} className={styles.value}>
            {t(`general_idType_${data.identificationDocument.type}`)} {data.identificationDocument.number}, platný do{' '}
            {sqlDateToLabel(data.identificationDocument.validTo, 'dd. MM. yyyy')}, vydal{' '}
            {data.identificationDocument.issuer}{' '}
            {data.identificationDocument.issuingCountry && <>({data.identificationDocument.issuingCountry})</>}
          </Grid>
        </Grid>
      </div>
      <div className={`${styles.twoColumns} ${styles.lines}`}>
        <Grid container>
          <Grid item xs={4}>
            E-mail:
          </Grid>
          <Grid item xs={8} className={styles.value}>
            {data.email}
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4}>
            Telefon:
          </Grid>
          <Grid item xs={8} className={styles.value}>
            {data.phone}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default PersonalData;
